import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import { Search } from 'lucide-react';
import classes from "./ChartAccount.module.css"
import plus from "../../../../Assets/plus.svg"
import ReportBackground from "../../../../Assets/report.svg"
import run from "../../../../Assets/run.svg"
import MailLogo from "../../../../Assets/mail.svg"
import PrintLogo from "../../../../Assets/print.svg"
import DownloadLogo from "../../../../Assets/down.svg"
import BackLogo from "../../../../Assets/back.svg"
import RotatingLogo from '../../../../Assets/rotating-logo.png'
import EyeIcon from "../../../../Assets/new-eye.svg"
import DeleteIcon from "../../../../Assets/new-delete.svg"
import PencilIcon from "../../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../../Accoungting/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../../Components/Styles/API/API";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import download from "../../../../Assets/download1.svg"
import upload from "../../../../Assets/upload.svg"
import logo from "../../../../Assets/rotating-logo.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Swal from "sweetalert2";

const ChartofAccount = () => {
  const location = useLocation();
  const [noData, setNoData] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectOptions, setSelectOptions] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [load, setLoad] = useState(false);
  const [ledgerData, setLedgerData] = useState([]);
  const [tableData3, setTableData3] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [selectedContinent, setSelectedContinent] = useState('');
  const [tableData45, setTableData45] = useState([]);
  const [totalDebit, setTotalDebit] = useState('');
  const [totalCredit, setTotalCredit] = useState('');
  const [allAccounts, setAllAccounts] = useState([]);
  const [fetchingLoading, setFetchingLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedBank, setSelectedBank] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [searchedResult, setSearchedResult] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [roleLoading, setRoleLoading] = useState(false);
  const [user, setUser] = useState('');
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(10); // Changed to 10 for better pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [savingsLoading, setSavingsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [cashbook, setCashbook] = useState([]);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [currentMonth, setCurrentMonth] = useState("");
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedEndDate, setSelectedEndDate] = useState('');
  const [inputss, setInputss] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const [admin, setAdmin] = useState('');
  const [isPrinting, setIsPrinting] = useState(false);
  const [continents, setContinents] = useState([]);
  const [regions, setRegions] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [selectedContinentFilter, setSelectedContinentFilter] = useState(null);
  const [selectedRegionFilter, setSelectedRegionFilter] = useState(null);
  const [selectedProvinceFilter, setSelectedProvinceFilter] = useState(null);
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [allAccountsData, setAllAccountsData] = useState([]); // Store all accounts for filtering

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const current = await localStorage.getItem('currentMonth');
      const admins = await localStorage.getItem('admin');
      const continentName = await localStorage.getItem('continent');
      const regionName = await localStorage.getItem('region');
      const provinceName = await localStorage.getItem('province');

      if (value !== null) {
        setBearer(value);
      }

      if (value1 !== null) {
        setUser(value1);
      }
      if (current !== null) {
        console.log(current);
        const date = new Date(current);
        setCurrentMonth(date);
        const startOfDateRange = new Date(1900, 0, 1);
        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));
        console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
      }
      if (admins !== null) {
        setAdmin(admins);
      }
      if (continentName !== null) {
        setContinent(continentName);
      }
      if (regionName !== null) {
        setRegion(regionName);
      }
      if (provinceName !== null) {
        setProvince(provinceName);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  useEffect(() => {
    const handleBeforePrint = () => setIsPrinting(true);
    const handleAfterPrint = () => setIsPrinting(false);

    window.addEventListener('beforeprint', handleBeforePrint);
    window.addEventListener('afterprint', handleAfterPrint);

    return () => {
      window.removeEventListener('beforeprint', handleBeforePrint);
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, []);

  function getTypeClass(description) {
    if (!description) return "";

    const lower = description.toLowerCase();

    if (lower.includes("current asset")) return "current-asset";
    if (lower.includes("non-current asset")) return "non-current-asset";
    if (lower.includes("current liabil")) return "current-liability";
    if (lower.includes("non-current liabil")) return "non-current-liability";
    if (lower.includes("equity")) return "equity";
    if (lower.includes("revenue") || lower.includes("income")) return "revenue";
    if (lower.includes("expense")) return "expense";

    return "default";
  }

  // Fetch chart of accounts data with proper pagination
  const fetchChartOfAccounts = async (page = 1) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/account/pagination?page=${page}&per_page=${entriesPerPage}`,
        { headers }
      );

      const data = response.data?.data;
      if (data) {
        const accountsData = data.data || [];
        setAllAccountsData(accountsData); // Store all accounts for filtering
        setTableData(accountsData);
        setTotalEntries(data.total || 0);
        setTotalPages(data.last_page || 1);
        setCurrentPage(data.current_page || page);
        console.log("Chart of accounts data:", accountsData);
      }
    } catch (error) {
      console.error("Error fetching chart of accounts:", error);
      setTableData([]);
      setAllAccountsData([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch province accounts when province is selected
  const fetchProvinceAccounts = async (page = 1) => {
    if (!selectedProvinceFilter) {
      Swal.fire({
        title: "Selection Required",
        text: "Please select continent, region and province to process accounts.",
        icon: "info",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      setLoading(true);
      const response = await axios.get(
        `${BASE_URL}/provinces/get-province-account-pagination?province_id=${selectedProvinceFilter.value}&page=${page}&per_page=${entriesPerPage}`,
        { headers }
      );

      if (response.data.status && response.data.data) {
        const accountsData = response.data.data.data || [];
        const paginationInfo = response.data.data;
        
        setTableData(accountsData);
        setTotalEntries(paginationInfo.total || accountsData.length);
        setTotalPages(paginationInfo.last_page || 1);
        setCurrentPage(paginationInfo.current_page || page);
        console.log("Province accounts data:", accountsData);
      } else {
        const accountsData = response.data.data || [];
        setTableData(accountsData);
        setTotalEntries(accountsData.length);
        setTotalPages(1);
        setCurrentPage(1);
      }
    } catch (error) {
      console.error("Error processing province accounts:", error);
      setTableData([]);
      setTotalEntries(0);
      setTotalPages(1);
      setCurrentPage(1);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchChartOfAccounts();
      fetchContinents();
    }
  }, [bearer]);

  // Fetch continents
  const fetchContinents = async () => {
    try {
      if (!bearer) return;
      setFiltersLoading(true);

      const response = await axios.get(`${BASE_URL}/continents`, { headers });

      if (response.data.status) {
        setContinents(response.data.data || []);
      } else if (Array.isArray(response.data)) {
        setContinents(response.data);
      } else if (response.data.data) {
        setContinents(response.data.data || []);
      } else {
        setContinents([]);
      }
    } catch (error) {
      console.error("Error fetching continents:", error);
      setContinents([]);
    } finally {
      setFiltersLoading(false);
    }
  };

  // Fetch regions based on selected continent
  const fetchRegions = async (continentId) => {
    if (!continentId) {
      setRegions([]);
      return;
    }

    try {
      setFiltersLoading(true);
      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${continentId}`, { headers });

      let regionsData = [];
      if (response.data.status && response.data.data) {
        if (Array.isArray(response.data.data)) {
          regionsData = response.data.data;
        } else if (response.data.data.regions && Array.isArray(response.data.data.regions)) {
          regionsData = response.data.data.regions;
        }
      } else if (Array.isArray(response.data)) {
        regionsData = response.data;
      } else if (response.data.data && Array.isArray(response.data.data)) {
        regionsData = response.data.data;
      }

      setRegions(regionsData || []);
    } catch (error) {
      console.error("Error fetching regions:", error);
      setRegions([]);
    } finally {
      setFiltersLoading(false);
    }
  };

  // Fetch provinces based on selected region
  const fetchProvincesForFilter = async (regionId) => {
    if (!regionId) {
      setProvinces([]);
      return;
    }

    try {
      setFiltersLoading(true);
      const response = await axios.get(`${BASE_URL}/regions/getprovincesregion?region_id=${regionId}`, { headers });

      let provincesData = [];
      if (response.data.status) {
        if (response.data.data && response.data.data.provinces) {
          provincesData = response.data.data.provinces;
        } else if (Array.isArray(response.data.data)) {
          provincesData = response.data.data;
        } else {
          provincesData = response.data.data || [];
        }
      } else if (Array.isArray(response.data)) {
        provincesData = response.data;
      } else if (response.data.data) {
        provincesData = response.data.data || [];
      }

      setProvinces(provincesData || []);
    } catch (error) {
      console.error("Error fetching provinces:", error);
      setProvinces([]);
    } finally {
      setFiltersLoading(false);
    }
  };

  // Handle continent filter change
  const handleContinentChange = (selectedOption) => {
    setSelectedContinentFilter(selectedOption);
    setSelectedRegionFilter(null);
    setSelectedProvinceFilter(null);
    setCurrentPage(1);
  };

  // Handle region filter change
  const handleRegionChange = (selectedOption) => {
    setSelectedRegionFilter(selectedOption);
    setSelectedProvinceFilter(null);
    setCurrentPage(1);
  };

  // Handle province filter change
  const handleProvinceChange = (selectedOption) => {
    setSelectedProvinceFilter(selectedOption);
    setCurrentPage(1);
  };

  // Process button handler
  const handleProcess = () => {
    if (selectedProvinceFilter) {
      fetchProvinceAccounts(1);
    } else {
      fetchChartOfAccounts(1);
    }
  };

  // Pagination handlers
  const handlePrevPage = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1;
      setCurrentPage(newPage);
      if (selectedProvinceFilter) {
        fetchProvinceAccounts(newPage);
      } else {
        fetchChartOfAccounts(newPage);
      }
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
      if (selectedProvinceFilter) {
        fetchProvinceAccounts(newPage);
      } else {
        fetchChartOfAccounts(newPage);
      }
    }
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
    if (selectedProvinceFilter) {
      fetchProvinceAccounts(page);
    } else {
      fetchChartOfAccounts(page);
    }
  };

  // Fetch regions when continent filter changes
  useEffect(() => {
    if (selectedContinentFilter) {
      fetchRegions(selectedContinentFilter.value);
    } else {
      setRegions([]);
      setSelectedRegionFilter(null);
      setSelectedProvinceFilter(null);
    }
  }, [selectedContinentFilter]);

  // Fetch provinces when region filter changes
  useEffect(() => {
    if (selectedRegionFilter) {
      fetchProvincesForFilter(selectedRegionFilter.value);
    } else {
      setProvinces([]);
      setSelectedProvinceFilter(null);
    }
  }, [selectedRegionFilter]);

  // Filter data based on search term
  const filteredData = tableData.filter(item => 
    item.gl_name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
    item.gl_code?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
    item.category?.description?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const startIndex = (currentPage - 1) * entriesPerPage + 1;
  const endIndex = Math.min(currentPage * entriesPerPage, totalEntries);
  const displayedData = filteredData;

  const handleShow1 = (loan) => {
    setLoanCode(loan.code);
    setLoanDescription(loan.description);
    setSelectedReportTo(loan.reportTo);
    setShow1(true);
  };

  const handleClose1 = () => setShow1(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleMail = () => alert("Mail clicked!");
  const handlePrinter = () => window.print();
  const handleDownload = () => {
    const csvContent = [
      ["Account Code", "Account Name", "Type", "Category", "Balance"],
      ...displayedData.map(d => [
        d.gl_code || "",
        d.gl_name || "",
        d.class?.description || "",
        d.category?.description || "",
        d.balance || ""
      ])
    ].map(e => e.join(",")).join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "chart_of_accounts.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const formattedTotalEntries = totalEntries.toLocaleString();

  // Prepare options for react-select
  const continentOptions = Array.isArray(continents)
    ? continents.map(continent => ({
      value: continent.id,
      label: continent.description || 'Unnamed Continent'
    }))
    : [];

  const regionOptions = Array.isArray(regions)
    ? regions.map(region => ({
      value: region.id,
      label: region.description || 'Unnamed Region'
    }))
    : [];

  const provinceOptions = Array.isArray(provinces)
    ? provinces.map(province => ({
      value: province.id,
      label: province.description || 'Unnamed Province'
    }))
    : [];

  // Pagination component
  const renderPagination = () => {
    const pages = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          className={`${classes.pageButton} ${currentPage === i ? classes.activePage : ''}`}
          onClick={() => handlePageClick(i)}
        >
          {i}
        </button>
      );
    }

    return (
      <div className={classes.paginationContainer}>
        <div className={classes.paginationControls}>
          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            className={classes.pageButton}
          >
            Previous
          </button>

          {pages}

          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className={classes.pageButton}
          >
            Next
          </button>

          <span className={classes.pageText}>
            Displaying {startIndex} - {endIndex} of {formattedTotalEntries}
          </span>
        </div>
      </div>
    );
  };

  const tableRef = useRef(null);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.backTxt}>
          <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={() => navigate(-1)} />
        </div>

        <div style={{ marginTop: 12 }} />
        <div className={classes.topNavBars}>
          <div className={classes.filterRow}>
            {/* Left side: Inputs */}
            <div className={classes.filterInputs}>
              {/* Continent Dropdown */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Continent:</label>
                {filtersLoading && continents.length === 0 ? (
                  <div style={{ width: 200, height: 36 }}>
                    <Skeleton height={36} borderRadius={4} />
                  </div>
                ) : (
                  <Select
                    value={selectedContinentFilter}
                    onChange={handleContinentChange}
                    options={continentOptions}
                    placeholder="Select Continent"
                    isClearable
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: 200,
                        fontSize: 12,
                      }),
                      control: (provided) => ({
                        ...provided,
                        minHeight: "36px",
                        fontSize: 12,
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        fontSize: 12,
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        fontSize: 12,
                        backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                        color: "#111827",
                      }),
                      menu: (provided) => ({
                        ...provided,
                        maxHeight: "300px",
                        maxWidth: "200px",
                        overflowY: "auto",
                        fontSize: 12,
                      }),
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    className={classes.inlineSelect}
                  />
                )}
              </div>

              {/* Region Dropdown */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Region:</label>
                {filtersLoading && selectedContinentFilter && regions.length === 0 ? (
                  <div style={{ width: 180, height: 36 }}>
                    <Skeleton height={36} borderRadius={4} />
                  </div>
                ) : (
                  <Select
                    value={selectedRegionFilter}
                    onChange={handleRegionChange}
                    options={regionOptions}
                    placeholder="Select Region"
                    isClearable
                    isDisabled={!selectedContinentFilter}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: 180,
                        fontSize: 12,
                      }),
                      control: (provided) => ({
                        ...provided,
                        minHeight: "36px",
                        fontSize: 12,
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        fontSize: 12,
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        fontSize: 12,
                        backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                        color: "#111827",
                      }),
                      menu: (provided) => ({
                        ...provided,
                        maxHeight: "300px",
                        maxWidth: "180px",
                        overflowY: "auto",
                        fontSize: 12,
                      }),
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    className={classes.inlineSelect}
                  />
                )}
              </div>

              {/* Province Dropdown */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Province:</label>
                {filtersLoading && selectedRegionFilter && provinces.length === 0 ? (
                  <div style={{ width: 180, height: 36 }}>
                    <Skeleton height={36} borderRadius={4} />
                  </div>
                ) : (
                  <Select
                    value={selectedProvinceFilter}
                    onChange={handleProvinceChange}
                    options={provinceOptions}
                    placeholder="Select Province"
                    isClearable
                    isDisabled={!selectedRegionFilter}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: 180,
                        fontSize: 12,
                      }),
                      control: (provided) => ({
                        ...provided,
                        minHeight: "36px",
                        fontSize: 12,
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        fontSize: 12,
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        fontSize: 12,
                        backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                        color: "#111827",
                      }),
                      menu: (provided) => ({
                        ...provided,
                        maxHeight: "300px",
                        maxWidth: "180px",
                        overflowY: "auto",
                        fontSize: 12,
                      }),
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    className={classes.inlineSelect}
                  />
                )}
              </div>

              <button 
                className={classes.loanBtn} 
                onClick={handleProcess}
                disabled={filtersLoading || loading}
              > 
                <img src={run} alt="run-report" /> 
                {filtersLoading || loading ? "Loading..." : "Process"} 
              </button>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 24 }} />

        <div className={classes.containere}>
          <div className={classes.iconbars}>
            <div className={classes.iconbarss}>
              <div className={classes.iconbar} onClick={handleMail} style={{ cursor: "pointer" }}>
                <img src={MailLogo} alt="icon1" className={classes.iconBtns} />
              </div>
              <div className={classes.iconbar} onClick={handlePrinter} style={{ cursor: "pointer" }}>
                <img onClick={handlePrint} src={PrintLogo} alt="icon2" className={classes.iconBtns} />
              </div>
              <div className={classes.iconbar} onClick={handleDownload} style={{ cursor: "pointer" }}>
                <img src={DownloadLogo} alt="icon3" className={classes.iconBtns} />
              </div>
            </div>
          </div>

          <header className={classes.headers}>
            <h1 className={classes.companyName}>Promix Accounting Ltd</h1>
            <h2 className={classes.title}>CHARTS OF ACCOUNTS</h2>
            <p className={classes.period}>For the period ended {new Date().toLocaleDateString()}</p>
            <button className={classes.unaudited}>unaudited</button>
          </header>

          <div className={classes.divider}></div>
          
          <div style={{ overflowX: 'auto', width: '100%' }}>
            <table className={classes.table} style={{ tableLayout: 'auto', width: '100%' }}>
              <thead>
                <tr className={classes.tableHeader}>
                  <th style={{ whiteSpace: "nowrap" }}>Account Code</th>
                  <th style={{ textAlign: 'left', width: '100%', whiteSpace: 'normal' }}>Account Name</th>
                  <th style={{ textAlign: 'left', whiteSpace: "nowrap" }}>Type</th>
                  <th style={{ textAlign: 'center', whiteSpace: "nowrap" }}>Category</th>
                  <th style={{ textAlign: 'right', whiteSpace: "nowrap" }}>Balance</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  // Skeleton loaders for table
                  Array.from({ length: 10 }).map((_, index) => (
                    <tr key={`skeleton-${index}`}>
                      <td><Skeleton height={20} borderRadius={4} /></td>
                      <td><Skeleton height={20} borderRadius={4} /></td>
                      <td><Skeleton height={20} borderRadius={4} /></td>
                      <td><Skeleton height={20} borderRadius={4} /></td>
                      <td><Skeleton height={20} borderRadius={4} /></td>
                    </tr>
                  ))
                ) : displayedData?.length > 0 ? (
                  displayedData.map((item, index) => (
                    <tr key={item.id} className={classes.tableRow}>
                      <td className={classes.textby} style={{ whiteSpace: 'nowrap' }}>{item.gl_code}</td>
                      <td className={classes.textby} style={{ whiteSpace: 'normal', width: '100%' }}>{item.gl_name}</td>
                      <td className={classes.textby} style={{ whiteSpace: 'nowrap', paddingRight: 20 }}>
                        <span className={`${classes.typeBadge} ${classes[getTypeClass(item.category?.description)]}`}>
                          {item.category?.description}
                        </span>
                      </td>
                      <td className={classes.textby} style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '150px',
                      }}>
                        {item.category?.description}
                      </td>
                      <td className={classes.textby} style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>{item.balance}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>
                      {selectedProvinceFilter 
                        ? `No province accounts found for ${selectedProvinceFilter?.label}` 
                        : "No chart ledger entries found."}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Proper Pagination */}
          {totalPages > 1 && renderPagination()}
        </div>
      </div>

      {savingsLoading && (
        <div className={classes.overlay}>
          <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
    </div>
  );
};

export default ChartofAccount;